<template>
  <b-modal 
    id="modal-confirmation" 
    centered 
    hide-footer 
    hide-header
    content-class="shadow border-0 custom-modal-width"
    :hide-backdrop="currentStep === 'success'"
  >
    <div v-if="currentStep === 'first'" class="text-center position-relative pt-4 pb-3 px-3">
      <button type="button" class="btn-close" @click="cancelDelete">&times;</button>
      <h5 class="mb-4">Are you really sure to delete?</h5>
      <div class="d-flex gap-3 justify-content-center">
        <button 
          type="button" 
          class="btn btn-primary px-5 py-2 big-no-button"
          @click="cancelDelete"
        >
          NO
        </button>
        <button 
          type="button" 
          class="btn btn-secondary px-4 py-2"
          @click="goToSecondConfirmation"
        >
          YES
        </button>
      </div>
    </div>

    <div v-if="currentStep === 'second'" class="text-center position-relative pt-4 pb-3 px-3">
      <button type="button" class="btn-close" @click="cancelDelete">&times;</button>
      <h5 class="mb-4">Are you really really sure to delete?</h5>
      <div class="d-flex flex-column gap-3 align-items-center">
        <button 
          type="button" 
          class="btn btn-primary px-6 py-3 big-no-button"
          @click="cancelDelete"
        >
          NO
        </button>
        <button 
          type="button" 
          class="btn btn-secondary px-4"
          @click="confirmDelete"
        >
          YES
        </button>
      </div>
    </div>

    <!-- Success step -->
    <div v-if="currentStep === 'success'" class="text-center position-relative pt-4 pb-3 px-3">
      <button type="button" class="btn-close" @click="closeSuccess">&times;</button>
      <h5 class="mb-4">Deleted</h5>
      <button 
        type="button" 
        class="btn btn-primary px-4"
        @click="closeSuccess"
      >
        OK
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'Confirmation',
  data() {
    return {
      currentStep: 'first',
      facilityId: null
    }
  },
  methods: {
    showConfirmation(id) {
      this.facilityId = id;
      this.currentStep = 'first';
      this.$bvModal.show('modal-confirmation');
    },
    
    goToSecondConfirmation() {
      this.currentStep = 'second';
    },
    
    async confirmDelete() {
      try {
        // Emit the deletion event to parent component
        this.$emit('confirm-delete', this.facilityId);
        
        // Show success step
        this.currentStep = 'success';
      } catch (error) {
        console.error('Delete failed:', error);
        this.cancelDelete();
      }
    },
    
    cancelDelete() {
      this.$bvModal.hide('modal-confirmation');
      // Reset after modal is hidden to prevent flash
      setTimeout(() => {
        this.currentStep = 'first';
        this.facilityId = null;
      }, 200);
      this.$emit('cancel-delete');
    },
    
    closeSuccess() {
      this.$bvModal.hide('modal-confirmation');
      // Reset after modal is hidden to prevent flash
      setTimeout(() => {
        this.currentStep = 'first';
        this.facilityId = null;
      }, 200);
      this.$emit('delete-complete');
    }
  }
}
</script>

<style scoped>
.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1000;
  line-height: 1;
}

.btn-close:hover {
  color: #666;
}

.gap-3 {
  gap: 1rem;
}

/* Custom styling for bigger NO button */
.big-no-button {
  font-size: 1.1rem;
  font-weight: bold;
  min-width: 120px;
}

/* Custom padding class for even more padding */
.px-6 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

/* Custom modal width */
:deep(.custom-modal-width) {
  max-width: 400px !important;
  width: 400px !important;
}
</style>